// extracted by mini-css-extract-plugin
export default {"container":"TopChoices_container__D5d2x","title":"TopChoices_title__O00qD","grid":"TopChoices_grid__EEg6h","emptyState":"TopChoices_emptyState__4IJbb"};